/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from 'react'; import { useLocation, useHistory } from 'react-router-dom';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import qs from 'qs';
import Table from './components/Table'
import NavRoutes from '../../../../components/Navs/NavRoutes';
import { AppearanceContext } from '../../index';
import { getErrorMessage } from '../../../../utils/helper';
import AlertComponent from '../../../../components/Alert';
import PageNotFound from '../../../404';
import { routesAppearance } from '../../helpers';
import { blogList } from '../../../../services/endpoints/blog';
import SearchInput from '../../../../components/Search/SearchInput';
import { useDebounce } from 'use-debounce';
import Loader from '../../../../components/Loaders/Loader';

const Blog = () => {
  const location = useLocation();
  const history = useHistory();

  const { config, menu } = useContext(AppearanceContext);

  const queryString = qs.parse(location.search.slice(1));
  const routeCreatePost = useMemo(() => routesAppearance.find((route) => route.code === 'create-blog'), [])

  const [init, setInit] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState({ page: true, table: false });
  const [searchQuery, setSearchQuery] = useState(queryString.query || '');
  const [searchDebounce] = useDebounce(searchQuery, 350);

  const { posts } = data;
  const fetchList = async () => {
    setIsLoading((prevState) => ({ ...prevState, table: true }));
    try {
      const response = await blogList(queryString);
      if (response.success) {
        setData({
          posts: response.data.blogs,
          filters: response.data.filters
        });
      }
      setIsLoading((prevState) => ({ ...prevState, table: false }));
      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setIsLoading((prevState) => ({ ...prevState, table: false }));
    }
  };

  const getAllData = async () => {
    setIsLoading((prevState) => ({ ...prevState, page: true }));

    try {
      if (config?.access?.blogs_list) {
        await fetchList(queryString);
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      } else {
        setIsLoading((prevState) => ({ ...prevState, page: false }));
      }
      setInit(true);
    } catch (error) {
      setIsLoading((prevState) => ({ ...prevState, page: false }));
    }
  }

  const onCreatePost = () => {
    history.push(routeCreatePost.link)
  }

  useEffect(() => {
    if (!init || (queryString.query === undefined && searchDebounce === '')) {
      return;
    }

    const newQuery = queryString ? { ...queryString } : {};
    if (searchDebounce) {
      newQuery.query = searchDebounce;
    } else {
      delete newQuery.query;
    }

    if (queryString.query !== searchDebounce) {
      history.push({
        pathname: location.pathname,
        search: qs.stringify(newQuery),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchDebounce])

  useEffect(() => {
    getAllData()
    document.title = 'Blog';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  if (isLoading.page && !init) {
    return <Loader />;
  }

  if (!config?.access?.blogs_list) {
    return <PageNotFound />
  }

  return (
    <Grid>
      <Row>
        <Col md={2} mdOffset={1}>
          <NavRoutes
            routes={menu}
          />
        </Col>
        <Col md={8}>
          <div className="loader-container" style={{ minHeight: '600px' }}>
            {error
              ? <AlertComponent text={error} />
              : (
                <div className='blog-table'>
                  <div className="blog-table__header">
                    <div>
                      {config?.access?.blogs_create ? <Button onClick={onCreatePost}>Add new post</Button> : null }
                    </div>
                    <div>
                      <SearchInput
                        placeholder="Search"
                        onChange={(e) => setSearchQuery(e.target.value)}
                        value={searchQuery}
                      />
                    </div>
                  </div>
                  {config?.access?.blogs_list
                    ? (
                      <div className="m-b">
                        <Table
                          items={posts || []}
                          config={config}
                          isLoading={isLoading.table}
                        />
                      </div>
                    ) : null }
                </div>
              )}
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default Blog;
